
import { ApiError } from "./ApiError";

// Keys webargs uses to say *where* it found the problem, not what the problem
// was. They are noise in an operator-facing message.
const LOCATION_KEYS = new Set(["json", "query", "form", "files", "headers", "cookies", "path"]);

/**
 * Flatten ms-accounting's `errors` envelope into one readable line.
 *
 * That service never answers with `message`. A conflict arrives as
 * `{"errors": ["409 Conflict: Bank account already exists"]}` and a validation
 * failure as `{"errors": {"json": {"document": ["Not a valid DNI"]}}}`, which
 * used to surface as "La solicitud falló con el estado 422" and left the
 * operator guessing which field was refused.
 */
function describeErrorsEnvelope(errors) {
    if (!errors) return "";
    if (typeof errors === "string") return errors;
    if (Array.isArray(errors)) return errors.map(describeErrorsEnvelope).filter(Boolean).join(" ");
    if (typeof errors !== "object") return String(errors);

    return Object.entries(errors)
        .map(([key, value]) => {
            const described = describeErrorsEnvelope(value);
            if (!described) return "";
            return LOCATION_KEYS.has(key) ? described : `${key}: ${described}`;
        })
        .filter(Boolean)
        .join(" ");
}

export async function handleApiResponse(res) {
    const contentType = res.headers.get("content-type");
    const isJson = contentType && contentType.includes("application/json");

    let body = null;
    if (isJson) {
        try {
            body = await res.json();
        } catch (e) {
            // body remains null if parsing fails
        }
    }

    if (!res.ok) {
        const message =
            body?.message ||
            body?.description ||
            describeErrorsEnvelope(body?.errors) ||
            `La solicitud falló con el estado ${res.status}`;
        const code = body?.code;
        throw new ApiError(message, { status: res.status, code, details: body });
    }

    return body;
}
